import React from "react";

const Contact = () => (
  <section id="contact" className="site-content" style={{ paddingTop: 12 }}>
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "1rem" }}>
      <h2 style={{ color: "var(--accent)" }}>Contact</h2>
      <p style={{ color: "var(--muted)" }}>Questions or partnership inquiries? Email <a href="mailto:help@rehdoggarcade.com" style={{ color: "var(--accent)" }}>help@rehdoggarcade.com</a>.</p>
    </div>
  </section>
);

export default Contact;
